var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5814 9.71055C30.5814 9.71055 24.0384 18.4211 15.7907 18.4211C7.54295 18.4211 1 9.71055 1 9.71055C1 9.71055 7.54295 1 15.7907 1C24.0384 1 30.5814 9.71055 30.5814 9.71055Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7906 14.937C12.7025 14.937 10.1905 12.5927 10.1905 9.71071C10.1905 6.82873 12.7025 4.48438 15.7906 4.48438C18.8788 4.48438 21.3908 6.82873 21.3908 9.71071C21.3908 12.5927 18.8788 14.937 15.7906 14.937Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7905 11.453C14.7614 11.453 13.9237 10.6712 13.9237 9.71086C13.9237 8.75049 14.7614 7.96875 15.7905 7.96875C16.8195 7.96875 17.6572 8.75049 17.6572 9.71086C17.6572 10.6712 16.8195 11.453 15.7905 11.453Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye2);
export default __webpack_public_path__ + "static/media/eye2.36a7b1396be952eb2dde8c12576026fc.svg";
export { ForwardRef as ReactComponent };